exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconfont.icon-d-excel[data-v-72d8274a]{font-size:70px!important}.iconfont.icon-download[data-v-72d8274a]{font-size:54px!important}[data-v-72d8274a] .el-upload-dragger{margin-top:25px}[data-v-72d8274a] .el-step.is-simple /deep/ .el-step__title{font-size:15px!important}.main-color[data-v-72d8274a]{color:var(--systemMainColor)}", ""]);

// exports
